import { render, staticRenderFns } from "./AIButton.vue?vue&type=template&id=88bff39a&scoped=true"
import script from "./AIButton.vue?vue&type=script&lang=js"
export * from "./AIButton.vue?vue&type=script&lang=js"
import style0 from "./AIButton.vue?vue&type=style&index=0&id=88bff39a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bff39a",
  null
  
)

export default component.exports